import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    open: false,
    type: "", // 'pdf' or 'excel'    
    message: "",
}

const exportSlice = createSlice({
    name: "export",
    initialState,
    reducers: {
        openExportLoader: (state, action) => {
            state.open = true;
            state.type = action.payload.type;
            state.message = action.payload.message;
        },
        closeExportLoader: (state) => {
            state.open = false;
            state.type = "";
            state.message = "";
        }
    }
})

export const { openExportLoader, closeExportLoader } = exportSlice.actions;
export default exportSlice.reducer;